var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdtErc20(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1098_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7809 24.6994V24.6966C24.6263 24.7078 23.8289 24.7556 22.05 24.7556C20.6297 24.7556 19.6298 24.7134 19.2783 24.6966V24.7008C13.8108 24.4603 9.72984 23.5083 9.72984 22.3692C9.72984 21.2316 13.8108 20.2795 19.2783 20.0348V23.753C19.6355 23.7783 20.6592 23.8387 22.0739 23.8387C23.7712 23.8387 24.622 23.7684 24.7809 23.7544V20.0377C30.2372 20.2809 34.3083 21.233 34.3083 22.3692C34.3083 23.5083 30.2372 24.4575 24.7809 24.6994V24.6994ZM24.7809 19.6509V16.3238H32.3944V11.25H11.6648V16.3238H19.2783V19.6495C13.0908 19.9336 8.4375 21.1598 8.4375 22.628C8.4375 24.0961 13.0908 25.3209 19.2783 25.6064V36.2686H24.7809V25.6036C30.9586 25.3195 35.6006 24.0947 35.6006 22.628C35.6006 21.1612 30.9586 19.9364 24.7809 19.6509",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7353 45.0001C40.8521 45.0001 45 40.8522 45 35.7354C45 30.6186 40.8521 26.4707 35.7353 26.4707C30.6185 26.4707 26.4706 30.6186 26.4706 35.7354C26.4706 40.8522 30.6185 45.0001 35.7353 45.0001Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0236 28.7871V33.9232L40.3646 35.863L36.0236 28.7871Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0237 28.7871L31.682 35.863L36.0237 33.9232V28.7871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0236 39.1909V42.6808L40.3675 36.6709L36.0236 39.1909Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0237 42.6808V39.1904L31.682 36.6709L36.0237 42.6808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0236 38.384L40.3646 35.8635L36.0236 33.9248V38.384Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.682 35.8635L36.0237 38.384V33.9248L31.682 35.8635Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1098_600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtErc20);
export default __webpack_public_path__ + "static/media/usdt_erc_20.eb08187753a37895a27d1414484d5ac6.svg";
export { ForwardRef as ReactComponent };